export default "<svg viewBox=\"0 0 9 9\" fill=\"none\"><circle cx=\"4.5\" cy=\"4.5\" r=\"4.5\"/></svg>";